import {
  requestExamCategory,
  requestExamList,
  requestExamInfo,
  requestExamCombo,
  requestExamDetail,
  requestExamHistory,
  requestExamTopScore,
  requestExamSubmit,
  requestExamPurchase,
  requestExamResponse,
  requestExamDetailPreview } from '../_api'
import router from '../../../router';

const getExamCategory = async (context, { id, page }) => {
  await requestExamCategory(id, page)
    .then((response) => {
      context.commit('SET_EXAM_CATEGORY', response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};

const getExamList = async (context, data) => {
  await requestExamList(data)
    .then((response) => {
      context.commit('SET_EXAM_LIST', response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};


const getExamInfo = async (context, id) => {
  await requestExamInfo(id)
    .then((response) => {
      context.commit('SET_EXAM', response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};

const getExamCombo = async (context, id) => {
  await requestExamCombo(id)
    .then((response) => {
      context.commit('SET_EXAM_COMBO', response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};

const getExamDetail = async (context, id) => {
  context.commit('SET_LOADING', true);

  await requestExamDetail(id)
    .then((response) => {
      context.commit('SET_EXAM_DETAIL', response.data.data);
      context.commit('SET_LOADING', false);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};
const getExamDetailPreview = async (context, id) => {
  context.commit('SET_LOADING', true);

  await requestExamDetailPreview(id)
    .then((response) => {
      console.log(response.data);
      context.commit('SET_EXAM_DETAIL', response.data.data);
      context.commit('SET_LOADING', false);
    })
    .catch(({ response }) => {
      if (response && response.data.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};
const getExamHistory = async (context, id) => {
  context.commit('SET_LOADING_HISTORY', true);

  await requestExamHistory(id)
    .then((response) => {
      context.commit('SET_EXAM_HISTORY', response.data);
      context.commit('SET_LOADING_HISTORY', false);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};

const getExamTopScore = async (context, id) => {
  context.commit('SET_LOADING_SCORE', true);

  await requestExamTopScore(id)
    .then((response) => {
      context.commit('SET_EXAM_SCORE', response.data);
      context.commit('SET_LOADING_SCORE', false);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};

const postExamSubmit = async (context, {id, slug, data, is_room}) => {
  var link_push = ''
  
  if(is_room == false) {
    link_push = { name: 'exam-detail', params: { id, slug } }
  } else {
    link_push = {name: 'thi-thu-lich-su'};
  }

  await requestExamSubmit(id, data)
    .then(() => {
      // context.commit('SET_EXAM_SUBMIT', response.data);
      router.push(link_push);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};

const getExamPurchase = async (context, { id, slug }) => {
  await requestExamPurchase(id, slug)
    .then(() => {
      router.push({ name: 'exam-response', params: { id: id, slug: slug } });
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};

const getExamDetailIndex = async (context, id) => {
  context.commit('SET_LOADING', true);

  await requestExamDetail(id)
    .then((response) => {
      context.commit('SET_EXAM_DETAIL_INDEX', response.data.data);
      context.commit('SET_LOADING', false);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};

const getExamResponse = async (context, id) => {
  context.commit('SET_LOADING', true);

  await requestExamResponse(id)
    .then((response) => {
      context.commit('SET_EXAM_RESPONSE', response.data);
      context.dispatch('getExamDetail', response.data.data.exam.id);
      context.commit('SET_LOADING', true);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit('SET_ERROR', response.data.errors);
      }
    });
};

const setExamStateSkill = (context, id) => {
  context.commit('SET_EXAM_SKILL', id);
};

const setExamStatePart = (context, id) => {
  context.commit('SET_EXAM_PART', id);
};

const setExamStateQuestion = (context, id) => {
  context.commit('SET_EXAM_QUESTION', id);
};

export default {
  getExamCategory,
  getExamList,
  getExamInfo,
  getExamCombo,
  getExamDetail,
  getExamDetailPreview,
  getExamHistory,
  getExamTopScore,
  postExamSubmit,
  getExamPurchase,
  getExamResponse,
  getExamDetailIndex,
  setExamStateSkill,
  setExamStatePart,
  setExamStateQuestion,
};